"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorInfoSection = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorInfoSection = ({
  errorMessage
}) => {
  if (!errorMessage) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
    mb: 3,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body2"
      // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
      ,
      sx: {
        whiteSpace: 'pre-wrap',
        color: 'error.main'
      },
      children: errorMessage
    })
  });
};
exports.ErrorInfoSection = ErrorInfoSection;
